module.exports = __webpack_public_path__ + "img/Number.bebcffd5.svg";